export class setDefaultId {
    static readonly type = "[Id] set default Id state";
    constructor() { }
}

export class getIdImage {
    static readonly type = "[Id] get id image";
}

export class setIdFile {
    static readonly type = "[Id] set id file";
    constructor(public payload: any) { }
}

export class getIdFile {
    static readonly type = "[Id] get id file";
}

export class requestIdFaceDetection {
    static readonly type = "[Id] get id faces";
    constructor(public payload: any) { }
}

export class setIdImageLoad {
    static readonly type = "[Id] set id document load";
    constructor(public payload: boolean) { }
}

export class idTimeOut {
    static readonly type = "[Id] set time out";
    constructor(public payload: boolean) { }
}
